"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _steps = _interopRequireWildcard(require("../rc-components/steps"));
var _ConfigContext = _interopRequireDefault(require("../config-provider/ConfigContext"));
var Steps = function Steps(props) {
  var customizePrefixCls = props.prefixCls;
  var _useContext = (0, _react.useContext)(_ConfigContext["default"]),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls('steps', customizePrefixCls);
  return /*#__PURE__*/_react["default"].createElement(_steps["default"], (0, _extends2["default"])({}, props, {
    prefixCls: prefixCls
  }));
};
Steps.displayName = 'Steps';
Steps.Step = _steps.Step;
Steps.StepGroup = _steps.StepGroup;
Steps.defaultProps = {
  iconPrefix: 'icon',
  current: 0
};
var _default = Steps;
exports["default"] = _default;